import { render } from "./ClientCheckList.vue?vue&type=template&id=2748c616&scoped=true"
import script from "./ClientCheckList.vue?vue&type=script&lang=js"
export * from "./ClientCheckList.vue?vue&type=script&lang=js"

import "./ClientCheckList.vue?vue&type=style&index=0&id=2748c616&scoped=true&lang=css"
import "./ClientCheckList.vue?vue&type=style&index=1&id=2748c616&lang=scss&scoped=true"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2748c616"]])

export default __exports__